module.exports = [
    "gmail.com",
    "yahoo.com",
    "protonmail.com",
    "ewura.go.tz",
    "maji.go.tz",
    "tamisemi.go.tz"

  ];
  